import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';
import api from '../services/api';

const GoogleCallbackPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [error, setError] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    const userParam = searchParams.get('user');
    const errorParam = searchParams.get('error');

    if (errorParam) {
      setError(`Google sign-in failed: ${errorParam}`);
      toast.error('Google sign-in failed. Please try again.');
      setTimeout(() => navigate('/login'), 2000);
      return;
    }

    if (token && userParam) {
      try {
        const user = JSON.parse(decodeURIComponent(userParam));
        api.setToken(token);
        api.setStoredUser(user);
        setUser(user);
        toast.success('Welcome!');
        navigate('/');
      } catch (err) {
        setError('Failed to process sign-in data');
        setTimeout(() => navigate('/login'), 2000);
      }
      return;
    }

    setError('Invalid callback. Please try again.');
    setTimeout(() => navigate('/login'), 2000);
  }, [searchParams, navigate, setUser]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <p className="text-red-600 mb-2">{error}</p>
          <p className="text-gray-500 text-sm">Redirecting to login...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-red-600 mx-auto mb-3" />
        <p className="text-gray-600">Signing you in with Google...</p>
      </div>
    </div>
  );
};

export default GoogleCallbackPage;
